import { render, staticRenderFns } from "./EnergyYearTable.vue?vue&type=template&id=32e05bcf&scoped=true&"
import script from "./EnergyYearTable.vue?vue&type=script&lang=js&"
export * from "./EnergyYearTable.vue?vue&type=script&lang=js&"
import style0 from "./EnergyYearTable.vue?vue&type=style&index=0&id=32e05bcf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e05bcf",
  null
  
)

export default component.exports